import { useQuery } from "@apollo/client";
import { GET_SHAREABLE_LINK_BY_ASSET } from "../gql";
import type { ShareableLink, ShareableLinksConnection } from "@casey/db-types";

interface GetShareableLinkByAssetResponse {
  shareableLinks: ShareableLinksConnection;
}

interface GetShareableLinkByAssetVariables {
  assetId: string;
  accessType?: string;
}

export function useShareableLinkByAsset(
  assetId: string,
  accessType: string = "open",
  options?: { skip?: boolean },
) {
  const { data, loading, error, refetch } = useQuery<
    GetShareableLinkByAssetResponse,
    GetShareableLinkByAssetVariables
  >(GET_SHAREABLE_LINK_BY_ASSET, {
    variables: { assetId, accessType },
    skip: !assetId || options?.skip,
  });

  return {
    shareableLink: data?.shareableLinks?.nodes?.[0] || null,
    loading,
    error,
    refetch,
  };
}
